$(document).ready(function () {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const hasHover = matchMedia("(hover: hover) and (pointer: fine)").matches;

  ScrollTrigger.config({
    ignoreMobileResize: true,
  });

  function openModal(modal) {
    modal[0].showModal();
    $("html, body").addClass("scroll-lock");
  }

  function closeModal() {
    $("dialog[open]")[0].close();
    $("html, body").removeClass("scroll-lock");
  }

  let clickStartedInsideDialog = false;

  $(document).on("mousedown", "dialog[open]", function (event) {
    clickStartedInsideDialog = event.target === this;
  });

  $(document).on("mouseup", "dialog[open]", function (event) {
    if (clickStartedInsideDialog && event.target === this) {
      $(".zones__item-popup.showed").removeClass("showed");
      setTimeout(closeModal, 250);
    }
    clickStartedInsideDialog = false;
  });

  $(".tab-js").on("click", function () {
    if (!$(this).hasClass("selected")) {
      let tabIndex = $(this).index();

      $(".tab-js.selected").removeClass("selected");
      $(".items-js.active").removeClass("active");

      $(this).addClass("selected");
      $(".items-js").eq(tabIndex).addClass("active");

      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
      });
    }
  });

  $(".popup").on("click", function () {
    $(this).hide();
  });

  $(document).on("click", "[data-metrika-goal]", function () {
    const goalId = $(this).data("metrika-goal");

    if (goalId && typeof ym === "function") {
      ym(107080003, "reachGoal", goalId);
    }
  });

  if (document.querySelector(".spa-page-tabs")) {
    const tabsContainer = document.querySelector("[data-tabs-container]");
    const tabsContent = document.querySelector("[data-tabs-content]");
    const tabs = tabsContainer.querySelectorAll("[data-tab]");
    const contents = tabsContent.querySelectorAll("[data-src]");
    const highPriceContainer = tabsContent.querySelector(
      ".high-price-container-js",
    );
    const highPriceList = document.querySelector(".high-price-list-js");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        contents.forEach((content) => {
          content.classList.remove("active");
        });
        tabs.forEach((tab) => {
          tab.classList.remove("selected");
        });
        tab.classList.add("selected");
        contents.forEach((content) => {
          if (
            tab.getAttribute("data-tab") === content.getAttribute("data-src")
          ) {
            content.classList.add("active");
          }
        });
        if (highPriceContainer.classList.contains("active")) {
          highPriceList.classList.add("active");
        } else {
          highPriceList.classList.remove("active");
        }

        requestAnimationFrame(() => {
          ScrollTrigger.refresh();
        });
      });
    });
  }

  if ($(".preloader").length) {
    const preloader = $(".preloader");

    function alreadyShown() {
      return sessionStorage.getItem("preloader_shown") === "1";
    }

    if (!alreadyShown()) {
      const video = preloader.find(".preloader__video");
      const videoEl = video.get(0);

      $("html, body").addClass("scroll-lock");
      preloader.addClass("active");

      $(".first-screen__video").each(function () {
        this.pause();
      });

      function finishPreloader() {
        $(document).trigger("preloader:finished");
        preloader.addClass("finished");

        setTimeout(function () {
          preloader.remove();
          $("html, body").removeClass("scroll-lock");
          $(document).trigger("preloader:unlocked");
        }, 1000);

        sessionStorage.setItem("preloader_shown", "1");
      }

      video.on("ended", function () {
        finishPreloader();
      });

      $(document).on("preloader:finished", function () {
        $(".first-screen__video").each(function () {
          this.play();
        });

        if (!$(".service-page").length) {
          initScrollTriggerAnimations();
        }
      });

      setTimeout(function () {
        if (videoEl.paused) {
          finishPreloader();
        }
      }, 1000);
    } else {
      preloader.remove();
    }
  }

  if ($(".contact-widget").length) {
    const widget = $(".contact-widget");
    let ticking = false;

    $(window).on("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          const scrollTop = $(window).scrollTop();
          const windowHeight = $(window).height();
          const footerOffsetTop = $(".footer").offset().top;

          if (
            scrollTop > windowHeight &&
            scrollTop < footerOffsetTop - windowHeight
          ) {
            widget.addClass("visible");
          } else {
            widget.removeClass("visible");
          }

          ticking = false;
        });

        ticking = true;
      }
    });

    $(".contact-widget__toggle").on("click", function () {
      widget.toggleClass("open");
    });
  }

  if ($(".header").length) {
    const header = $(".header");
    let prevScroll = $(window).scrollTop();
    let ticking = false;

    $(window).on("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          let currentScroll = $(window).scrollTop();

          if (currentScroll > prevScroll && currentScroll > 0) {
            header.addClass("hidden");
          } else {
            header.removeClass("hidden");
          }

          prevScroll = currentScroll;
          ticking = false;
        });

        ticking = true;
      }
    });

    $(".header__menu-item--dropdown > .header__menu-link").on(
      "click",
      function (event) {
        event.preventDefault();
      },
    );

    $(".header__mob-menu .header__menu-link[href^='#']").on(
      "click",
      function () {
        const mobMenu = $(".header__mob-menu");

        if (mobMenu.hasClass("active")) {
          mobMenu.removeClass("active");
          $("html, body").removeClass("scroll-lock");
          mobMenu.fadeOut();
        }
      },
    );

    $(".header__menu-button").on("click", function () {
      const mobMenu = $(".header__mob-menu");
      mobMenu.toggleClass("active");
      $("html, body").toggleClass("scroll-lock");

      if (mobMenu.hasClass("active")) {
        mobMenu.fadeIn();
        mobMenu.css("display", "flex");
      } else {
        mobMenu.fadeOut();
      }
    });

    $(window).on("resize", function () {
      if (
        $(".header__mob-menu").hasClass("active") &&
        window.matchMedia("(max-width: 1200px)").matches
      ) {
        const mobMenu = $(".header__mob-menu");
        mobMenu.toggleClass("active");
        $("html, body").toggleClass("scroll-lock");

        if (mobMenu.hasClass("active")) {
          mobMenu.fadeIn();
          mobMenu.css("display", "flex");
        } else {
          mobMenu.fadeOut();
        }
      }
    });

    $(".header__mob-menu .header__menu-item--dropdown").on(
      "click",
      function () {
        const dropdown = $(this).find(".header__dropdown-menu");

        if (dropdown.hasClass("expanded")) {
          dropdown.slideUp(150);
          dropdown.removeClass("expanded");
          $(this).removeClass("active");
        } else {
          dropdown.slideDown(300);
          dropdown.addClass("expanded");
          $(this).addClass("active");
        }
      },
    );

    $(".header__language").on("click", function () {
      $(".header__language-switcher").toggleClass("toggled");
    });
  }

  if ($(".first-screen").length) {
    if ($(".first-screen--homepage").length) {
      gsap.set(".first-screen--homepage", { position: "fixed" });

      let pinTrigger;

      function initFirstScreenAnimation() {
        if (pinTrigger) {
          pinTrigger.kill();
          pinTrigger = null;
        }

        pinTrigger = ScrollTrigger.create({
          trigger: ".first-screen--homepage",
          start: "bottom bottom",
          end: "bottom top",
          scrub: true,
          pin: true,
          pinSpacing: false,
        });
      }

      initFirstScreenAnimation();

      let lastWidth = Math.round($(window).width());

      $(window).on("resize", function () {
        const currentWidth = Math.round($(window).width());

        if (currentWidth !== lastWidth) {
          lastWidth = currentWidth;
          initFirstScreenAnimation();
        }
      });
    }

    const duration = window.matchMedia("(max-width: 1024px)").matches ? 0.7 : 1;
    const delay = window.matchMedia("(max-width: 1024px)").matches ? 0.2 : 0.3;

    gsap.to(".first-screen__line", {
      scrollTrigger: {
        trigger: ".first-screen",
        start: "top bottom",
      },
      width: "100%",
      duration: duration,
      delay: delay,
    });
  }

  if ($(".zones").length) {
    const duration = window.matchMedia("(max-width: 1024px)").matches ? 1 : 1.5;

    $(".zones__item").each(function () {
      gsap.from(this, {
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=10%",
        },
        clipPath: "inset(0 100% 0 0)",
        duration: duration,
        delay: 0.3,
        ease: "power4.out",
      });
    });

    $(".zones__items").on("click", ".zones__item", function () {
      $(this).one("transitionend", function () {
        requestAnimationFrame(() => {
          ScrollTrigger.refresh();
        });
      });
    });

    $(".zones__items").on("click", ".zones__item:not(.expanded)", function () {
      const wrapper = $(this).find(".zones__item-wrapper");

      $(this).addClass("expanded");
      wrapper.addClass("visible");
    });

    $(".zones__items").on(
      "click",
      ".zones__item.expanded .zones__item-btn",
      function () {
        const zone = $(this).closest(".zones__item");
        const wrapper = zone.find(".zones__item-wrapper");

        zone.removeClass("expanded");
        wrapper.removeClass("visible");
      },
    );
  }

  $("[zones-open-btn]").on("click", function () {
    const zone = $(this).closest("[zones-item]");
    const popup = zone.find(".zones__item-popup");

    openModal(popup);

    setTimeout(() => {
      popup.addClass("showed");
    }, 0);

    if (
      $(".spa-page-prices").length &&
      !$(".first-screen--homepage").length &&
      window.matchMedia("(min-width: 1025px)").matches
    ) {
      ScrollTrigger.normalizeScroll(false);
    }
  });

  $(".spa-page-tab-block__info-title-block").on("click", function () {
    if (window.matchMedia("(max-width: 1024px)").matches) {
      const parent = $(this).parent();
      const serviceIncludes = parent.find(".spa-page-tab-block__info-wrapper");

      if (parent.hasClass("expanded")) {
        serviceIncludes.slideUp(150);
        parent.removeClass("expanded");
      } else {
        serviceIncludes.slideDown(300);
        parent.addClass("expanded");
      }
    }
  });

  $(".zones__item-popup-close-btn").on("click", function () {
    $(".zones__item-popup.showed").removeClass("showed");

    setTimeout(closeModal, 250);

    if (
      $(".spa-page-prices").length &&
      !$(".first-screen--homepage").length &&
      window.matchMedia("(min-width: 1025px)").matches
    ) {
      ScrollTrigger.normalizeScroll(true);
    }
  });

  if ($(".spa-gallery").length) {
    let animationTl;
    let animationScrollTrigger;
    let pinTrigger;

    function initSpaGalleryAnimation() {
      if (animationTl) {
        animationTl.kill();
        animationTl = null;
      }

      if (animationScrollTrigger) {
        animationScrollTrigger.kill();
        animationScrollTrigger = null;
      }

      if (pinTrigger) {
        pinTrigger.kill();
        pinTrigger = null;
      }

      const blockHeight = $(".spa-menu").outerHeight();

      pinTrigger = ScrollTrigger.create({
        trigger: ".spa-gallery",
        start: "bottom bottom",
        end: `+=${blockHeight}`,
        scrub: true,
        pin: true,
        pinSpacing: false,
      });

      animationTl = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: ".spa-gallery",
          start: "top top",
          end: "bottom bottom",
          scrub: 1,
          pin: ".spa-gallery__sticky",
          pinSpacing: false,

          onEnter: () => {
            pinTrigger.disable();
          },

          onEnterBack: () => {
            pinTrigger.disable();
          },

          onLeave: () => {
            pinTrigger.enable();
          },

          onLeaveBack: () => {
            pinTrigger.enable();
          },

          onRefreshInit(self) {
            animationScrollTrigger = self;
          },
        },
      });

      const scale = window.matchMedia("(max-width: 1024px)").matches
        ? 0.7
        : 0.6;

      animationTl.fromTo(
        ".spa-gallery__rows",
        {
          scale: 1,
          transformOrigin: "center center",
        },
        {
          scale: scale,
        },
        0,
      );

      animationTl.fromTo(
        ".spa-gallery__image",
        {
          clipPath: "inset(0px)",
        },
        {
          clipPath: "inset(10px round 10px)",
          ease: "expo.out",
        },
        0,
      );

      if (window.matchMedia("(min-width: 768px)").matches) {
        animationTl.fromTo(
          ".spa-gallery__title",
          {
            scale: 1,
          },
          {
            scale: 0.83,
            ease: "none",
          },
          0,
        );

        animationTl.fromTo(
          ".spa-gallery__text",
          {
            scale: 1,
          },
          {
            scale: 0.71,
            ease: "none",
          },
          0,
        );

        animationTl.fromTo(
          ".spa-gallery__content",
          {
            gap: 32,
          },
          {
            gap: 0,
            ease: "none",
          },
          0,
        );
      } else {
        animationTl.fromTo(
          ".spa-gallery__text",
          {
            scale: 1,
          },
          {
            scale: 0.83,
            ease: "none",
          },
          0,
        );

        animationTl.fromTo(
          ".spa-gallery__content",
          {
            gap: 32,
          },
          {
            gap: 20,
            ease: "none",
          },
          0,
        );
      }
    }

    initSpaGalleryAnimation();

    if (window.location.pathname === "/") {
      let lastWidth = Math.round($(window).width());

      $(window).on("resize", function () {
        const currentWidth = Math.round($(window).width());

        if (currentWidth !== lastWidth) {
          lastWidth = currentWidth;
          initSpaGalleryAnimation();
        }
      });
    }
  }

  if ($(".spa-menu").length) {
    $(".spa-menu__item").each(function (i) {
      const duration = window.matchMedia("(max-width: 1024px)").matches
        ? 1
        : 1.5;
      const delay = window.matchMedia("(max-width: 767px)").matches
        ? 0.3
        : (i + 1) * 0.1;

      gsap.from(this, {
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=10%",
        },
        clipPath: "inset(0 100% 0 0)",
        duration: duration,
        delay: delay,
        ease: "power4.out",
      });
    });

    const video = $(".spa-menu__video");
    video.removeAttr("autoplay");

    if (hasHover) {
      $(".spa-menu__item").on("mouseenter", function () {
        const video = $(this).find(".spa-menu__video");
        const wrapper = $(this).find(".spa-menu__item-wrapper");

        video[0].play();
        wrapper.addClass("visible");
      });

      $(".spa-menu__item").on("mouseleave", function () {
        const video = $(this).find(".spa-menu__video");
        const wrapper = $(this).find(".spa-menu__item-wrapper");

        video[0].pause();
        wrapper.removeClass("visible");
      });
    }
  }

  if ($(".promo").length) {
    const duration = 8000;

    const backgroundsSlider = new Splide(".promo__backgrounds-slider", {
      direction: "ttb",
      type: "loop",
      autoplay: true,
      interval: duration,
      pauseOnHover: false,
      drag: false,
      height: "100%",
      pagination: false,
      speed: 700,
    });

    const titlesSlider = new Splide(".promo__titles-slider", {
      direction: "ttb",
      type: "loop",
      drag: false,
      height: "57px",
      arrows: false,
      pagination: false,
      speed: 700,
    });

    const tagsSlider = new Splide(".promo__tags-slider", {
      type: "fade",
      drag: false,
      arrows: false,
      pagination: false,
      speed: 700,
    });

    const imagesSlider = new Splide(".promo__images-slider", {
      direction: "ttb",
      type: "loop",
      drag: false,
      width: "338px",
      height: "304px",
      arrows: false,
      pagination: false,
      speed: 700,
      breakpoints: {
        767: {
          width: "230px",
          height: "207px",
        },
      },
    });

    const descriptionsSlider = new Splide(".promo__descriptions-slider", {
      type: "fade",
      drag: false,
      arrows: false,
      pagination: false,
      speed: 700,
    });

    const buttonsSlider = new Splide(".promo__buttons-slider", {
      type: "fade",
      drag: false,
      arrows: false,
      pagination: false,
      speed: 0,
    });

    backgroundsSlider.sync(titlesSlider);
    backgroundsSlider.sync(tagsSlider);
    backgroundsSlider.sync(imagesSlider);
    backgroundsSlider.sync(descriptionsSlider);
    backgroundsSlider.sync(buttonsSlider);

    let raf = null;

    function startProgress() {
      if (raf) {
        cancelAnimationFrame(raf);
      }

      const start = performance.now();

      function tick(now) {
        const elapsed = now - start;
        const t = Math.min(elapsed / duration, 1);
        const val = t * 360;

        $(".promo__arrows").css("--progress", val + "deg");

        if (t < 1) {
          raf = requestAnimationFrame(tick);
        }
      }

      raf = requestAnimationFrame(tick);
    }

    backgroundsSlider.on("mounted move", startProgress);

    titlesSlider.mount();
    tagsSlider.mount();
    imagesSlider.mount();
    descriptionsSlider.mount();
    buttonsSlider.mount();
    backgroundsSlider.mount();

    $(".promo").on("click", function () {
      backgroundsSlider.Components.Autoplay.pause();
      cancelAnimationFrame(raf);
      $(".promo__arrows").css("--progress", "0deg");
    });

    function setTitleHeight() {
      let maxHeight = 0;

      $(".promo__titles-slider .promo__title").each(function () {
        const height = $(this).outerHeight();

        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      titlesSlider.options = { height: `${maxHeight + 4}px` };
    }

    setTitleHeight();

    const breakpoint = window.matchMedia("(min-width: 768px)");

    $(breakpoint).on("change", function () {
      setTitleHeight();
    });

    const totalSlides = backgroundsSlider.length;

    if (totalSlides < 2) {
      backgroundsSlider.options = { arrows: false };
    }

    backgroundsSlider.on("move", function (newIndex) {
      $(".promo__number").text(`${newIndex + 1} / ${totalSlides}`);
    });
  }

  if ($(".reviews").length) {
    let reviewsPinTrigger;
    let reviewsTl;

    function initReviewsAnimation() {
      if (reviewsTl) {
        reviewsTl.kill();
        reviewsTl = null;
      }

      const duration = window.matchMedia("(max-width: 1024px)").matches
        ? 0.7
        : 1;

      reviewsTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".promo",
          start: "bottom bottom",
          end: "bottom top",
          pin: ".reviews",
          pinSpacing: false,
          scrub: 2,

          onEnter: () => gsap.set(".reviews", { top: 0 }),
          onEnterBack: () => gsap.set(".reviews", { top: 0 }),
          onLeave: () => gsap.set(".reviews", { clearProps: "all" }),
          onLeaveBack: () => gsap.set(".reviews", { clearProps: "all" }),
        },
      });

      reviewsTl.fromTo(
        ".reviews__title",
        {
          yPercent: 100,
        },
        {
          yPercent: 0,
          duration: duration,
          ease: "power3.out",
        },
        3,
      );

      reviewsTl.fromTo(
        ".reviews__slider",
        {
          xPercent: 100,
          x: 24,
        },
        {
          xPercent: 0,
          x: 0,
          duration: 1.5,
          ease: "power3.out",
        },
        ">",
      );

      reviewsTl.to(
        ".reviews__title-wrap",
        {
          opacity: 0,
          duration: 1,
          ease: "power3.out",
        },
        "<",
      );

      reviewsTl.to(
        ".reviews__background",
        {
          opacity: 0,
          duration: 1,
          ease: "power3.out",
        },
        "<",
      );
    }

    initReviewsAnimation();

    if (window.location.pathname === "/") {
      let lastWidth = Math.round($(window).width());

      $(window).on("resize", function () {
        const currentWidth = Math.round($(window).width());

        if (currentWidth !== lastWidth) {
          lastWidth = currentWidth;
          initReviewsAnimation();
        }
      });
    }

    const reviewsSlider = new Splide(".reviews__slider", {
      autoWidth: true,
      gap: 12,
      pagination: false,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        767: {
          gap: 8,
        },
      },
    });

    reviewsSlider.on("overflow", function (isOverflow) {
      reviewsSlider.options = {
        drag: isOverflow,
        arrows: isOverflow,
      };
    });

    reviewsSlider.mount();

    const sliderEl = $(".reviews__slider");
    let wheelLocked = false;

    sliderEl.on("wheel", function (event) {
      const originalEvent = event.originalEvent;

      if (Math.abs(originalEvent.deltaX) > Math.abs(originalEvent.deltaY)) {
        event.preventDefault();

        if (wheelLocked) return;
        wheelLocked = true;

        if (originalEvent.deltaX > 0) {
          reviewsSlider.go(">");
        } else {
          reviewsSlider.go("<");
        }

        setTimeout(() => {
          wheelLocked = false;
        }, 300);
      }
    });
  }

  if ($(".contacts").length) {
    const duration = window.matchMedia("(max-width: 1024px)").matches ? 0.7 : 1;
    const delay = window.matchMedia("(max-width: 1024px)").matches ? 0.2 : 0.3;

    gsap.to(".contacts__line--horizontal", {
      scrollTrigger: {
        trigger: ".contacts",
        start: "top bottom-=10%",
      },
      width: "100%",
      duration: duration,
      delay: delay,
    });

    gsap.to(".contacts__line--vertical", {
      scrollTrigger: {
        trigger: ".contacts",
        start: "top bottom-=10%",
      },
      height: "100%",
      duration: duration,
      delay: delay,
    });
  }

  if ($(".banner__line").length) {
    const duration = window.matchMedia("(max-width: 1024px)").matches ? 0.7 : 1;
    const delay = window.matchMedia("(max-width: 1024px)").matches ? 0.2 : 0.3;

    ScrollTrigger.matchMedia({
      "(max-width: 767px)": function () {
        gsap.to(".banner__line", {
          scrollTrigger: {
            trigger: ".banner",
            start: "top bottom-=10%",
          },
          width: "100%",
          duration: duration,
          delay: delay,
        });
      },

      "(min-width: 768px)": function () {
        gsap.to(".banner__line", {
          scrollTrigger: {
            trigger: ".banner",
            start: "top bottom-=10%",
          },
          height: "100%",
          duration: duration,
          delay: delay,
        });
      },
    });
  }

  function setupServicePageAnimations() {
    const mm = gsap.matchMedia();

    mm.add("(max-width: 1024px)", function () {
      initScrollTriggerAnimations();
    });

    mm.add("(min-width: 1025px)", function () {
      if (!$(".first-screen--homepage").length) {
        ScrollTrigger.normalizeScroll(true);
      }

      const video = $(".service-page-animation");
      const services = $(".services:not(.services--extra)");
      const servicesPaddingTop = parseFloat(services.css("padding-top"));
      const servicesContent = services.find(".services__content");
      const servicesItems = services.find(".services__items.active");
      const servicesWrapper = servicesItems.closest(".services__wrapper");

      const animationTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".service-page",
          start: "top top",
          end: () => "+=" + window.innerHeight * 2.5,
          scrub: 1,
          pin: true,
        },
      });

      initScrollTriggerAnimations({ exclude: ".services" });

      animationTl.to(
        video,
        {
          width: "40vw",
          ease: "power4.inOut",
          duration: 0.6,
        },
        0,
      );

      [
        ".service-page-animation__title",
        ".service-page-animation__caption",
        ".service-page-animation__line",
      ].forEach(function (selector) {
        if (!$(selector).length) {
          return;
        }

        animationTl.fromTo(
          selector,
          {
            opacity: 1,
          },
          {
            opacity: 0,
            duration: 0.6,
            ease: "power4.inOut",
          },
          0,
        );
      });

      const vw40 = $(window).width() * 0.4;
      const vh80 = $(window).height() - servicesPaddingTop - 120;
      const height = Math.min(vw40, vh80) + "px";

      animationTl.to(
        video,
        {
          height: height,
          borderRadius: "4px",
          ease: "power4.inOut",
          duration: 0.4,
        },
        "-=0.2",
      );

      if (servicesContent.length) {
        animationTl.to(
          video,
          {
            top: () => {
              const videoTop = video.offset().top;
              const servicesContentTop = servicesContent.offset().top;
              return servicesContentTop - videoTop;
            },
            ease: "power4.inOut",
            duration: 0.4,
          },
          "<",
        );
      }

      let animationsPlayed = false;

      animationTl.call(
        () => {
          if (!animationsPlayed) {
            initScrollTriggerAnimations({ scope: ".services" });
            services.addClass("showed");
            ScrollTrigger.refresh();

            animationsPlayed = true;
          }
        },
        null,
        "<",
      );

      let ticking = false;

      $(window).on("scroll", function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            const servicesItems = services.find(".services__items.active");
            const parent = servicesItems.closest(".services__column");
            const parentHeight = parent.outerHeight();
            const parentOffsetTop = parent.offset().top;
            const videoHeight = video.outerHeight();
            const scrollTop = $(window).scrollTop();

            const maxTranslate = Math.max(0, parentHeight - videoHeight);

            let y = scrollTop - parentOffsetTop + servicesPaddingTop;
            y = Math.max(0, Math.min(y, maxTranslate));

            video.css("transform", `translateY(${y}px)`);

            ticking = false;
          });

          ticking = true;
        }
      });

      $(".services__item-top").on("click", function () {
        const bottom = $(this).next(".services__item-bottom");

        bottom.one("transitionend", function () {
          requestAnimationFrame(() => {
            ScrollTrigger.refresh();
          });
        });
      });
    });
  }

  if ($(".service-page").length) {
    if ($(".preloader.active").length) {
      $(document).one("preloader:unlocked", setupServicePageAnimations);
    } else {
      setupServicePageAnimations();
    }
  }

  if ($(".services--extra").length) {
    const duration = window.matchMedia("(max-width: 1024px)").matches ? 1 : 2;

    gsap.from(".services__image", {
      scrollTrigger: {
        trigger: ".services__image",
        start: "top bottom-=10%",
      },
      clipPath: "inset(0 100% 0 0)",
      duration: duration,
      delay: 0.3,
      ease: "power4.out",
    });
  }

  if ($(".spa-page-additional").length) {
    const servicesPaddingTop = parseFloat(
      $(".services:not(.services--extra)").css("padding-top"),
    );

    if (window.matchMedia("(min-width: 1025px)").matches) {
      let ticking = false;

      $(window).on("scroll", function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            const image = $(".sticky-image-animation");
            const parent = image.closest(".services__content");
            const items = parent.find(".services__items");
            const itemsHeight = items.outerHeight();
            const itemsOffsetTop = items.offset().top;
            const imageHeight = image.outerHeight();
            const scrollTop = $(window).scrollTop();

            const maxTranslate = Math.max(0, itemsHeight - imageHeight);

            let y = scrollTop - itemsOffsetTop + servicesPaddingTop;
            y = Math.max(0, Math.min(y, maxTranslate));

            image.css("transform", `translateY(${y}px)`);

            ticking = false;
          });

          ticking = true;
        }
      });
    }
  }

  if ($(".faq").length) {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", function () {
      gsap.from(".faq__image", {
        scrollTrigger: {
          trigger: ".faq__image",
          start: "top bottom-=10%",
        },
        clipPath: "inset(0 100% 0 0)",
        duration: 2,
        delay: 0.3,
        ease: "power4.out",
      });
    });
  }

  if ($(".certificates").length) {
    const range = $(".certificates__range-input");
    const amount = $(".certificates__range-amount");
    const checkoutSum = $(".certificates__checkout-sum-value");
    const hiddenAmount = $(".certificates__checkout-amount");

    const values = range.data("values");

    function updateSum() {
      const index = parseInt(range.val(), 10);
      const sum = values[index];

      amount.text(sum.toLocaleString("ru-RU") + " ₽");
      checkoutSum.text(sum.toLocaleString("ru-RU") + " ₽");
      hiddenAmount.val(sum);
    }

    range.on("input", updateSum);

    $(".certificates__form").on("submit", function (event) {
      event.preventDefault();

      openModal($(".certificates__checkout"));

      setTimeout(() => {
        $(".certificates__checkout").addClass("showed");
      }, 0);
    });

    $('input[name="phone"]').mask("+7 (900) 000-00-00");

    const checkoutForm = $(".certificates__checkout-form");
    const checkoutSubmitBtn = checkoutForm.find(
      ".certificates__checkout-submit",
    );

    function ensureErrorSpan(field) {
      let error = field.find(".certificates__checkout-error");

      if (!error.length) {
        error = $('<span class="certificates__checkout-error"></span>');
        field.append(error);
      }

      return error;
    }

    function updateSubmitBtnState() {
      let allValid = true;

      checkoutForm.find("input[required]").each(function () {
        if (!this.validity.valid) {
          allValid = false;
          return false;
        }
      });

      if (!allValid) {
        checkoutSubmitBtn.addClass("invalid");
      } else {
        checkoutSubmitBtn.removeClass("invalid");
      }
    }

    updateSubmitBtnState();

    checkoutForm.on("input change", "input[required]", function () {
      const field = $(this).closest(".certificates__checkout-field");

      if (this.validity.valid) {
        $(this).removeClass("is-invalid");
        field.find(".certificates__checkout-error").remove();
      }

      updateSubmitBtnState();
    });

    checkoutForm.on("submit", function (event) {
      event.preventDefault();

      const form = $(this);
      const submit = form.find(".certificates__checkout-submit");
      let isValid = true;

      form.find(".certificates__checkout-error").remove();
      form.find(".is-invalid").removeClass("is-invalid");

      form.find("input[required]").each(function () {
        if (!this.validity.valid) {
          isValid = false;
          const field = $(this).closest(".certificates__checkout-field");

          $(this).addClass("is-invalid");
          ensureErrorSpan(field).text(this.validationMessage);
        }
      });

      if (!isValid || submit.prop("disabled")) return;
      submit.prop("disabled", true);

      $.ajax({
        url: ajax.url,
        type: "POST",
        data: {
          action: "certificate_create_order",
          certificate_checkout_nonce: ajax.certificate_nonce,
          recipient: form.find("#recipient").val(),
          email: form.find("#email").val(),
          phone: form.find("#phone").val(),
          comment: form.find("#comment").val(),
          amount: form.find("#amount").val(),
          consent_rules: form.find("#consent_rules").is(":checked")
            ? 1
            : undefined,
          consent_personal: form.find("#consent_personal").is(":checked")
            ? 1
            : undefined,
          consent_privacy: form.find("#consent_privacy").is(":checked")
            ? 1
            : undefined,
        },
        dataType: "json",
        success: function (response) {
          if (response.success && response.data.payment_url) {
            window.location.href = response.data.payment_url;
          } else {
            alert(response.data?.message || "Произошла ошибка");
            submit.prop("disabled", false);
          }
        },
        error: function (jqXHR) {
          const msg =
            jqXHR.responseJSON?.data?.message ||
            "Произошла ошибка. Попробуйте ещё раз.";
          alert(msg);
          submit.prop("disabled", false);
        },
      });
    });

    $(".certificates__popup-close-btn").on("click", function () {
      $(".certificates__popup.showed").removeClass("showed");

      setTimeout(closeModal, 250);
    });

    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get("payment_status");

    if (paymentStatus && $(".certificates__result").length) {
      const resultDialog = $(".certificates__result");

      openModal(resultDialog);

      setTimeout(() => {
        resultDialog.addClass("showed");
      }, 0);

      if (paymentStatus === "success") {
        const goalId = $(".certificates__result--success").data("metrika-goal");

        if (goalId && typeof ym === "function") {
          ym(107080003, "reachGoal", goalId);
        }
      }

      const cleanUrl = new URL(window.location);
      cleanUrl.searchParams.delete("payment_status");
      cleanUrl.searchParams.delete("payment_order");
      window.history.replaceState({}, "", cleanUrl);
    }
  }

  function initScrollTriggerAnimations(opts) {
    opts = opts || {};

    const root = opts.scope ? $(opts.scope) : $(document);
    const exclude = opts.exclude ? $(opts.exclude) : null;

    function pick(selector) {
      let elems = root.find(selector);

      if (exclude && exclude.length) {
        elems = elems.filter(function () {
          return $(this).closest(exclude).length === 0;
        });
      }
      return elems;
    }

    pick(".show-on-scroll").each(function () {
      const duration = window.matchMedia("(max-width: 1024px)").matches
        ? 0.7
        : 1;
      let delay = window.matchMedia("(max-width: 1024px)").matches ? 0.2 : 0.3;
      delay =
        $(this).hasClass("first-screen__content") ||
        $(this).hasClass("intro__content")
          ? 0
          : delay;

      gsap.to(this, {
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=10%",
        },
        opacity: 1,
        visibility: "visible",
        duration: duration,
        delay: delay,
        ease: "power3.out",
      });
    });

    pick(".text-line-reveal").each(function () {
      const container = this;
      let lines;

      const existingLines = $(container).find(".text-line");

      if (existingLines.length) {
        lines = existingLines.toArray();
      } else {
        const split = new SplitText(container, {
          type: "lines",
          linesClass: "text-line-wrap",
        });

        lines = [];

        $(split.lines).each(function () {
          const inner = $('<span class="text-line"></span>');

          inner.append($(this).contents());
          $(this).append(inner);

          lines.push(inner[0]);
        });
      }

      const start =
        $(container).hasClass("first-screen__name") ||
        $(container).hasClass("spa-page__name")
          ? "top bottom"
          : "top bottom-=10%";
      const duration = window.matchMedia("(max-width: 1024px)").matches
        ? 0.7
        : 1;
      const delay = window.matchMedia("(max-width: 1024px)").matches
        ? 0.2
        : 0.3;

      gsap.from(lines, {
        scrollTrigger: {
          trigger: container,
          start: start,
          onEnter: () => {
            container.classList.add("showed");
          },
        },
        yPercent: 100,
        duration: duration,
        delay: delay,
        ease: "power4.out",
      });
    });

    pick(".services__item-line").each(function () {
      const duration = window.matchMedia("(max-width: 1024px)").matches
        ? 0.7
        : 1;
      const delay = window.matchMedia("(max-width: 1024px)").matches
        ? 0.2
        : 0.3;

      gsap.to(this, {
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=10%",
        },
        width: "100%",
        duration: duration,
        delay: delay,
      });
    });
  }

  if (!$(".preloader").length && !$(".service-page").length) {
    initScrollTriggerAnimations();
  }

  ScrollTrigger.refresh();
});
